import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faChevronRight, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';



@Component({
  selector: 'mpro-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent<T extends {name: string}> implements OnInit {
  @Input() breadcrumbs: ReadonlyMap<string, T > | null
  @Output() breadcrumbClicked: EventEmitter<KeyValue<string, T>> = new EventEmitter()
  public faChevronRight = faChevronRight;
  public faMapMarker = faMapMarkerAlt

  constructor() { }

  ngOnInit(): void {
  }

  //Ensures that breadcrumbs order is not changed by keyvalue sort
  originalOrder = (a: KeyValue<string, T>, b: KeyValue<string, T>): number => {
    return 0;
  }

  public breadcrumbSelected(breadcrumb?: KeyValue<string, T>){
    this.breadcrumbClicked.emit(breadcrumb)
  }

}
